import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useEditAIPromptTemplate } from '../api/editAIPromptTemplate';
import { Fields } from '../hooks/useAIPromptTemplateForm';
import { aiPromptTemplatesTypes } from '../types';

import { AIPromptTemplateForm } from './AIPromptTemplateForm';

type EditModalProps = {
  template: aiPromptTemplatesTypes.AIPromptTemplate;
};

export const EditModal = NiceModal.create(({ template }: EditModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useEditAIPromptTemplate({
    config: {
      onSuccess: () => modal.hide(),
    },
  });

  const initialValues: Fields = {
    aiId: template.aiId,
    template: template.template,
  };

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Edit Prompt Template"
      size="lg"
    >
      <AIPromptTemplateForm
        isLoading={isLoading}
        onSubmit={(params) =>
          mutate({
            _id: template._id,
            ...params,
          })
        }
        initialValues={initialValues}
        submitLabel="Save"
      />
    </Modal>
  );
});
